import { DEFAULT_FUNNEL_ID, DEFAULT_FUNNELS, TEMPLATES } from "../config.js";
import type { AppState, Funnel, Template } from "../types.ts";

function cloneFunnels(funnels: Funnel[]): Funnel[] {
  return funnels.map((funnel) => ({
    id: funnel.id,
    title: funnel.title,
    stages: funnel.stages.map((stage) => ({ ...stage })),
  }));
}

export const initialState: AppState = {
  userEmail: "",
  authToken: "",
  user: null,
  loginError: "",
  loginPending: false,
  connectionStatus: "offline",
  leads: [],
  funnels: cloneFunnels(DEFAULT_FUNNELS as Funnel[]),
  activeFunnelId: DEFAULT_FUNNEL_ID,
  templates: TEMPLATES as Template[],
  templateId: "primeiro",
  shortcuts: [],
  view: "loading",
  panel: "kanban",
  query: "",
  tagFilter: "",
  selectedLeadId: "",
  cadenceDraftLeadId: "",
  cadenceSchedulerOpen: false,
  newLeadAlertIds: [],
  bulkSelectedLeadIds: [],
  theme: "light",
  whatsappSession: null,
  accounts: [],
  accountFilter: [],
  chats: [],
  activeChatJid: "",
  chatMessages: {},
  chatLoading: {},
  composer: { text: "", chatJid: "" },
  qrPolling: false,
  chatListSearch: "",
  chatListFilter: "all",
  chatTags: [],
  chatContextMenu: null,
};
